/* unplugin-vue-components disabled */import script from "./GraphMemory.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphMemory.vue?vue&type=script&setup=true&lang=js"

import "./GraphMemory.vue?vue&type=style&index=0&id=c63c81f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c63c81f4"]])

export default __exports__